<body>

  <div class="main-wrapper">
    <div class="main-content">
      <header>

        <div class="head-line">

          <p>Client List</p>
        </div>
        <div class="user-wrapper">
          <p>{{storedData.agencyRefId.agencyName}}</p>

          <div>
            <img class="log1"
              [src]="this.storedData.agencyRefId.logo?this.storedData.agencyRefId.logo:'../../../../assets/images/user1.jpeg'">
          </div>
        </div>
      </header>

      <main class="main-2">

        <div class="container">
          <div class="projects">


            <div class="two-screen">
              <!---sec sidebar-->


              <div class="main-side">
                <span (click)="navigateBack()">
                 <i class="fa-solid fa-circle-arrow-left" style="cursor:pointer;font-size: 30px;" title="back"></i>
                </span>
                <div class="agency-head" id="agency-h1">

                  <input type="file" id="fileInput" class="file-input-bg-edit" (change)="upload('clientLogo',$event)">
                  <label for="fileInput" class="file-label">
                    <img alt="User Image" (click)="ImageOpen(clientForm.value.clientLogo)"
                      style="cursor: pointer;    object-fit: cover;"
                      src="{{clientForm.value.clientLogo ? clientForm.value.clientLogo:'../../../../assets/images/user-no.jpg'}}">
                    <img src="../../assets/images/plus-black.png" class="plus-b"></label>


                  <div>
                    <button class="stat-btn">

                      <span>{{this.workData.status}}</span>
                    </button>

                  </div>
                </div>


                <form class="staff-form" [formGroup]="clientForm">

                  <div class="row">
                    <div class="col-lg-6 col-xs-12 col-sm-6">
                      <div class="form-group">
                        <label>Ref. ID*</label>
                        <input type="text" class="form-control" formControlName="clientRefId" readonly
                          [(ngModel)]="this.workData.clientRefId.clientRefId" placeholder="Type here">
                      </div>
                    </div>
                    <div class="col-lg-6 col-xs-12 col-sm-6">
                      <div class="form-group">
                        <label>Initiated date*</label>
                        <input type="text" class="form-control" readonly [value]="formatDate(workData.createdAt)"
                          placeholder="Type here">
                      </div>
                    </div>
                    <div class="col-lg-6 col-xs-12 col-sm-6">
                      <div class="form-group">
                        <label>Initiated by*</label>
                        <input type="text" class="form-control" formControlName="initiatedBy" readonly
                          [(ngModel)]="this.workData.clientRefId?.initiatedBy.name" placeholder="Type here" *ngIf="workData.type!='Client'">
                         <input type="text" class="form-control" formControlName="initiatedBy" readonly
                          [(ngModel)]="this.workData?.initiatedBy.name" placeholder="Type here" *ngIf="workData.type=='Client'">

                     
                        </div>
                    </div>
                    <div class="col-lg-6 col-xs-12 col-sm-6">
                      <div class="form-group">
                        <label>Updated date*</label>
                        <input type="text" class="form-control" readonly [value]="formatDate(workData.updatedAt)"
                          placeholder="Type here">
                      </div>
                    </div>
                    <div class="col-lg-6 col-xs-12 col-sm-6">
                      <div class="form-group">
                        <label>Allocated to BackEnd Staff : {{ workData?.clientRefId.allocatedTo?.name || '' }}

                        </label>

                        <!-- <select class="select-al" formControlName="allocatedTo"
                          (change)="AllocateStaff()">
                          <option *ngFor="let staff of this.staffs" [ngValue]="staff">
                            {{staff.name}}
                          </option>

                        </select> -->

                        <select class="select-al" *ngIf="workData.status=='New case'" formControlName="allocatedTo"
                          (change)="AllocateStaff()">
                          <option *ngFor="let staff of this.staffs" [ngValue]="staff">
                            {{staff.name}}
                          </option>

                        </select>

                      </div>
                      <div class="form-group">
                        <label
                          *ngIf="workData.status !== 'New case' && workData.status !== 'Under Validation'">Allocated to
                          Telecaller :{{ workData?.teleCallerId?.name || '' }}
                        </label>

                        <select class="select-al" *ngIf="workData.status=='Verified'" [(ngModel)]="this.teleCaller"
                          [ngModelOptions]="{standalone:true}">
                          <option *ngFor="let staff of this.telleCallers" [ngValue]="staff">
                            {{staff.name}}
                          </option>

                        </select>

                      </div>



                      <!-- <label *ngIf="workData.status == 'Verified'">Product wise TelleCaller Assignments</label> -->

                      <!-- <div class="product-assignment" *ngIf="workData.status == 'Verified'">
  <div *ngFor="let product of workData.NonAlloocatedProducts; let i = index" class="form-row">
    <div class="col-left">
      <label>{{ product.name }} :</label>
    </div>

    <div class="col-right">
      <select class="form-select"
              [(ngModel)]="product.teleCallerId"
              [ngModelOptions]="{standalone: true}">
        <option [ngValue]="null">-- Select Telecaller --</option>
        <option *ngFor="let staff of telleCallers" [ngValue]="staff._id">
          {{ staff.name }}
        </option>
      </select>
    </div>
  </div>
</div> -->



                      <!-- <div class="mt-3">
  <button class="btn btn-primary" (click)="submitAssignments()">Save Assignments</button>
</div> -->
















                    </div>
                    <div class="col-lg-6 col-xs-12 col-sm-6">

                      <div class="form-group" style="display: grid;">
                        <label>Country*</label>
                        <input type="email" class="form-control" formControlName="clientCountry"
                          [(ngModel)]="this.workData.clientRefId.clientCountry" placeholder="Type here"
                          [readonly]="!isEditing">

                        <!-- <select class="select-al"  formControlName="clientCountry" [(ngModel)]="this.workData.clientCountry">
                              <option disabled>Select Counrty</option>
                              <option value="india">India</option>
                              <option value="uae">UAE</option>
                            </select> -->
                      </div>
                    </div>


                    <div class="col-lg-6 col-xs-12 col-sm-6">

                      <div class="form-group" style="display: grid;">
                        <label>location</label>
                        <!-- <input type="email" class="form-control"   formControlName="clientCountry"  [(ngModel)]="this.workData.clientCountry" placeholder="Type here"> -->

                        <select class="select-al" formControlName="location"
                          [(ngModel)]="this.workData.clientRefId.location" [readonly]="!isEditing">
                          <!-- <option disabled>Select Counrty</option> -->
                          <!-- <option value="india">India</option> -->
                          <option *ngFor="let item of locations">{{item}}</option>

                        </select>
                      </div>
                    </div>

                     <div class="col-lg-6 col-xs-12 col-sm-6">
                      <div class="form-group" style="margin-top: 29px;">
                        
                           <input type="checkbox" id="selectAll" [(ngModel)]="isChecked"  [checked]="isChecked"
                     style="margin-bottom: 10px;margin-right: 10px;font-size: 15px;" formControlName="isFreeZone"/>
                     <label style="font-size: 15px;">Freezone*</label>

                      </div>
                    </div>
                    <div class="col-lg-12 col-xs-12 col-sm-6">
                      <div class="form-group">
                        <label>Company name*</label>
                        <input type="email" class="form-control" formControlName="clientName"
                          [(ngModel)]="this.workData.clientRefId.clientName" clientCountryplaceholder="Type here"
                          [readonly]="!isEditing">
                      </div>
                    </div>

                    <div class="col-lg-12 col-xs-12 col-sm-6">
                      <div class="form-group">
                        <label>Product</label>

                        <ng-multiselect-dropdown [settings]="dropdownSettings" [data]="productDetails"
                          [(ngModel)]="this.workData.products" (onSelect)="onDropdownClose()" formControlName="products"
                          [disabled]="!isEditing">
                        </ng-multiselect-dropdown>
                      </div>
                    </div>

                    <div class="col-lg-12 col-xs-12 col-sm-6">
                      <div class="form-group">
                        <label>Company address*</label>
                        <textarea class="form-control" placeholder="Type here" formControlName="clientAddress"
                          [(ngModel)]="this.workData.clientRefId.clientAddress" style="height: 167px;"
                          [readonly]="!isEditing"></textarea>

                      </div>
                    </div>

                    <div class="col-lg-12 col-xs-12 col-sm-6">
                      <div class="form-group">
                        <div *ngFor="let question of this.workData.clientRefId.clientQuestion" class="form-group">
                          <label>{{ question.displayName }} </label>

                          <ng-container [ngSwitch]="question.type">

                            <input *ngSwitchCase="'text'" type="text" class="form-control user-in"
                              [(ngModel)]="question.value" [name]="question.field" [required]="question.required"
                              [maxlength]="question.characterLimit" [ngModelOptions]="{standalone:true}"
                              (ngModelChange)="checkTextLength(question)" [readonly]="!isEditing" />
                            <div *ngIf="question.required && !question.value&&submitted&&question.type=='text'"
                              class="text-danger">
                              This field is required.
                            </div>
                            <!-- <div *ngIf="question.characterLimit && question.value?.length > question.characterLimit&&question.type=='text" class="text-danger">
                                Maximum {{ question.characterLimit }} characters allowed.
                              </div> -->

                            <!-- Number Input -->
                            <input *ngSwitchCase="'number'" type="number" class="form-control user-in"
                              [(ngModel)]="question.value" [name]="question.field" [required]="question.required"
                              [ngModelOptions]="{standalone:true}" [readonly]="!isEditing" />
                            <div *ngIf="question.required && !question.value&&submitted&&question.type=='number'"
                              class="text-danger">
                              This field is required.
                            </div>

                            <!-- Month Input -->
                            <input *ngSwitchCase="'month'" type="month" class="form-control user-in"
                              [(ngModel)]="question.value" [name]="question.field" [required]="question.required"
                              [ngModelOptions]="{standalone:true}" [readonly]="!isEditing" />
                            <div *ngIf="question.required && !question.value&&submitted&&question.type=='month'"
                              class="text-danger">
                              This field is required.
                            </div>

                            <!-- Time Input -->
                            <input *ngSwitchCase="'time'" type="time" class="form-control user-in"
                              [(ngModel)]="question.value" [name]="question.field" [required]="question.required"
                              [ngModelOptions]="{standalone:true}" [readonly]="!isEditing" />
                            <div *ngIf="question.required && !question.value&&submitted&&question.type=='time'"
                              class="text-danger">
                              This field is required.
                            </div>

                            <!-- Date Input -->
                            <input *ngSwitchCase="'date'" type="date" class="form-control user-in"
                              [(ngModel)]="question.value" [name]="question.field" [required]="question.required"
                              [ngModelOptions]="{standalone:true}" [readonly]="!isEditing" />
                            <div *ngIf="question.required && !question.value&&submitted&&question.type=='date'"
                              class="text-danger">
                              This field is required.
                            </div>

                            <!-- TextCaps Input with Character Limit -->
                            <input *ngSwitchCase="'textcaps'" type="text" class="form-control user-in"
                              style=" text-transform: uppercase;" [(ngModel)]="question.value" [name]="question.field"
                              [required]="question.required" [maxlength]="question.characterLimit"
                              [ngModelOptions]="{standalone:true}"
                              (input)="question.value = question.value.toUpperCase()" [readonly]="!isEditing" />
                            <div
                              *ngIf="question.required && !question.value&&submitted&&submitted&&question.type=='textcaps'"
                              class="text-danger">
                              This field is required.
                            </div>
                            <!-- <div *ngIf="question.characterLimit && question.value?.length > question.characterLimit&&submitted&&question.type=='textcaps" class="text-danger">
                                Maximum {{ question.characterLimit }} characters allowed.
                              </div>  -->




                            <!-- Select Input with Dynamic Options -->
                            <select *ngSwitchCase="'select'" class="form-control user-in" [(ngModel)]="question.value"
                              [ngModelOptions]="{standalone:true}" [name]="question.field" [disabled]="!isEditing">
                              <option *ngFor="let option of question.valueList || []" [value]="option">
                                {{ option }}
                              </option>
                            </select>
                            <div
                              *ngIf="(question.value === 'other'||question.value === 'Other'||question.value === 'OTHER') && question.type === 'select'"
                              class="mt-2">
                              <input type="text" class="form-control" [(ngModel)]="question.otherValue"
                                [ngModelOptions]="{standalone: true}" placeholder="Enter new value"
                                [readonly]="!isEditing" />

                            </div>
                          </ng-container>
                        </div>
                      </div>
                    </div>


                    <p class="blue-head">Validations</p>

                    <div class="col-lg-12 col-xs-12 col-sm-10 bd-1">
                      <div class="sm-1">
                        <div class="form-group">
                          <label>Company website*</label>
                          <input type="text" class="form-control" formControlName="companyWebsite"
                            [(ngModel)]="this.workData.clientRefId.companyWebsite" placeholder="Type here"
                            [readonly]="!isEditing">
                        </div>
                        <div>
                          <img src="../../assets/images/devicon_google.png" class="img-icon"
                            (click)="windowOpen(this.workData.clientRefId.companyWebsite,'google')">
                        </div>
                        <div>
                          <img src="../../assets/images/mdi_internet.png" class="img-icon"
                            (click)="windowOpen(this.workData.clientRefId.companyWebsite,'site')">
                        </div>
                      </div>
                    </div>
                    <br>
                    <div class="col-lg-12 col-xs-12 col-sm-10 bd-1">

                      <div class="sm-1">
                        <div class="form-group">
                        </div>
                      </div>
                    </div>

                    <div class="col-lg-12 col-xs-12 col-sm-10 bd-1">
                      <div class="sm-1">
                        <div class="form-group">
                          <label class="green-head ">Email*</label>
                          <div (click)="openTemplateSelection()" title="Send Email">
                            Click here to send template: <img src="../../assets/images/mail.png" alt="Send" style="width: 38px;
    height: 38px;
">
                          </div>
                        </div>
                        <div (click)="addEmail()" *ngIf="isEditing">
                          <div class="btn-plus"><img src="../../assets/images/plus.png"></div>
                        </div>

                      </div>
                    </div>
                    <div class="col-lg-12 col-xs-12 col-sm-10 bd-1" formArrayName="email">
                      <div class="sm-1" *ngFor="let securityDetail of clientEmail.controls; let i=index">
                        <div class="form-group">
                          <input type="text" [formControlName]="i" class="form-control" placeholder="Type here"
                            oninput="this.value = this.value.replace(/[\s\t]/g, '')" [readonly]="!isEditing" />






                          <div *ngIf="clientFormControl.status=='INVALID' && (submitted)"
                            style="color: red;font-size: 12px;">
                            <p *ngIf="isPatternError(clientFormControl.controls[i])" style="color: red;">Invalid Email
                            </p>
                          </div>
                        </div>

                        <div>
                          <button *ngIf="workData.status=='Under Validation'"
                            [ngStyle]="{ 'background-color': clientFormControl.controls[i].status!='INVALID'&&  this.clientForm.value.email[i] ? 'green' : '' }">
                            <p>{{ clientFormControl.controls[i].status!='INVALID'&&this.clientForm.value.email[i] ?
                              'Verified' : 'Verify' }}</p>
                          </button>
                          <button (click)="DeleteEmail(i)"><img src="../../assets/images/Delete.png"></button>
                        </div>

                      </div>
                    </div>

                    <!-- <div class="col-lg-12 col-xs-12 col-sm-10 bd-1">
                          <div class="sm-2">
                            <div class="form-group">
    
                              <input type="text" class="form-control" placeholder="Type here">
                            </div>
                           
                            <div>
                              <button><img src="../../assets/images/icon.png">
                                <p>Verify</p>
                              </button>
                            </div>
    
                          </div>
                        </div> -->
                    <!-- <div class="col-lg-12 col-xs-12 col-sm-10 bd-1">

                      <div class="sm-1">
                        <div class="form-group">
                          <label class="green-head ">Sender Name</label>
                            <input type="text" class="form-control" placeholder="Sender Name" 
                            formControlName="senderName"
                          [(ngModel)]="this.workData.clientRefId.senderName">
                        </div>
                      </div>
                    </div> -->

                    <div class="col-lg-12 col-xs-12 col-sm-10 bd-1">
                      <div class="sm-1">
                        <div class="form-group">
                          <label class="green-head ">Whatsapp contact</label>
                          <!-- <input type="text" class="form-control" placeholder="Type here"> -->
                        </div>
                        <div (click)="addWhatsapp()" *ngIf="isEditing">
                          <div class="btn-plus"><img src="../../assets/images/plus.png"></div>
                        </div>
                      </div>
                    </div>
                    <div formArrayName="whatsAppContact">
                      <div *ngFor="let securityDetail of clientWhatsAppDetails.controls; let i=index" class="row"
                        [formGroupName]="i">
                        <div class="col-lg-3 col-xs-12 col-sm-5">
                          <div class="form-group">
                            <label>Name*</label>
                            <input type="email" class="form-control" formControlName="name"
                              (input)="validatePhoneLength(securityDetail.value.whatsappNumber,securityDetail)"
                              placeholder="Type here" [readonly]="!isEditing">
                          </div>
                        </div>


                        <div class="col-lg-3 col-xs-12 col-sm-5">
                          <div class="form-group">
                            <label>Designation*</label>
                            <input type="email" class="form-control" formControlName="designation"
                              (input)="validatePhoneLength(securityDetail.value.whatsappNumber,securityDetail)"
                              placeholder="Type here" [readonly]="!isEditing">
                          </div>
                        </div>
                        <div class="col-lg-3 col-xs-12 col-sm-10 bd-1">
                          <div class="sm-1">
                            <div class="form-group">
                              <label>Number*</label>
                              <input type="text" class="form-control"
                                (input)="validatePhoneLength(securityDetail.value.whatsappNumber,securityDetail)"
                                formControlName="whatsappNumber" placeholder="Type here"
                                *ngIf="workData.status!='Under Validation'" [readonly]="!isEditing">

                              <input type="text" class="form-control" *ngIf="workData.status=='Under Validation'"
                                ng2TelInput [ng2TelInputOptions]="{
                                initialCountry: securityDetail.value.whatsappNumber? getCode(securityDetail.value.whatsappNumber,securityDetail) : 'AE',
                                nationalMode: false,
                                formatOnDisplay: false 
                              }" (input)="validatePhoneLength(securityDetail.value.whatsappNumber,securityDetail)"
                                (intlTelInputObject)="telInputObject($event)"
                                (onCountryChange)="onCountryChange($event)"
                                oninput="this.value = this.value.replace(/[^0-9+\-]|(?!^)\+/g, '')"
                                formControlName="whatsappNumber" placeholder="Type here" [readonly]="!isEditing">

                              <div
                                *ngIf="workData.status=='Under Validation'&&securityDetail.value.check==false&&submitted"
                                style="color: red;font-size: 12px;">
                                <p>{{ securityDetail.value.check==true?'Valid Data':'Invalid Data '}} </p>
                              </div>

                              <div
                                *ngIf="whatsAppContact.status=='INVALID' && (submitted)&&workData.status!='Under Validation'"
                                style="color: red;font-size: 12px;">
                                <p *ngIf="isPatternError1(whatsAppContact.controls[i])" style="color: red;">Invalid </p>
                              </div>

                            </div>
                            <div *ngIf="workData.status=='Under Validation'">
                              <button [ngStyle]="{ 'background-color': securityDetail.value.check ? 'green' : '' }"
                                (click)="validatePhoneLength(securityDetail.value.whatsappNumber,securityDetail)"><img
                                  src="../../assets/images/icon.png">
                                <p>{{ securityDetail.value.check==true?'Verified':'Verify '}}
                                </p>
                              </button>

                            </div>

                            <button style="    margin-left: 59px;background: white;" (click)="DeleteWhatsapp(i)"><img
                                src="../../assets/images/Delete.png">

                            </button>

                            <button
                              *ngIf="workData.status !== 'New case' && workData.status !== 'Under Validation' && workData.status !== 'Verified'"
                              style="    margin-left: 59px;background: white;"><img
                                src="../../assets/images/ph-vector.png">

                            </button>

                          </div>


                        </div>

                        <div class="col-lg-1 col-xs-12 col-sm-1"
                          *ngIf="workData.status !== 'New case' && workData.status !== 'Under Validation' && workData.status !== 'Verified'">
                          <div class="form-group">
                            <!-- <label>DND</label> -->
                            <label class="toggle">
                              <input type="checkbox" formControlName="Dnd"
                                [disabled]="(securityDetail.value.Dnd && storedData.userType[0].userType !== 'Client Admin')||!isEditing"
                                (change)="handleToggle(i, $event)"> <span class="slider"></span>
                            </label>
                            <!-- <p style="margin-left: 66px;">  {{securityDetail.value.Dnd}}</p>  -->

                          </div>
                        </div>&nbsp;&nbsp;&nbsp;&nbsp;
                        <div class="col-lg-1 col-xs-12 col-sm-1"
                          *ngIf="workData.status !== 'New case' && workData.status !== 'Under Validation' && workData.status !== 'Verified'">
                          <div class="form-group">
                            <label>Dnd User*</label>
                            <input type="email" class="form-control" formControlName="DndUser" placeholder="Type here"
                              [readonly]="!isEditing">
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="audio-one" *ngFor="let item of workData.clientAudio">
                      <audio *ngIf="item" controls>
                        <source [src]="item" type="audio/wav">
                      </audio>
                      <!-- <div class="del-img" (click)="removeAudio(item,i)">
                            <img src="../../assets/images/Delete.png">
                          </div> -->
                    </div>

                    <div class="col-lg-8 col-xs-12 col-sm-6 ext-padding">
                      <div class="col-lg-12 col-xs-12 col-sm-6">
                        <label class="mb-0">Add location</label>
                        <table class="agency-table mt-2" id="ag-t1">
                          <tbody>
                            <tr>
                              <td class="dot-width">
                                <img src="../../assets/images/google-map.png">
                              </td>
                              <td>

                                <div>
                                  <p class="name-two">Location</p>
                                  <p class="name-one">
                                    {{this.clientForm.value.clientGMap?this.clientForm.value.clientGMap.address:''}}</p>
                                </div>
                              </td>
                              <td>
                                <div class="content">
                                  <button class="btn-two" (click)="showMaps()" [disabled]="!isEditing">Add Google
                                    Map</button>
                                </div>
                              </td>
                            </tr>

                          </tbody>
                        </table>
                      </div>

                      <div class="col-lg-12 col-xs-12 col-sm-6">
                        <label>Photos*</label>
                        <div class="form-group img-slide mt-0">
                          <div class="image-upload">
                            <input type="file" id="fileInputClient" class="file-input-bg-edit"
                              (change)="upload('clientPhotos',$event)">
                            <label for="fileInputClient" class="file-label">
                              <img alt="User Image" src="../../assets/images/no-img.jpg" class="user-img">
                              <img src="../../assets/images/plus-black.png" class="plus-img">
                            </label>
                          </div>
                          <div *ngFor="let data of clientForm.value.clientPhotos" style="cursor: pointer;">
                            <img [src]="data" style="width: 70px; height: 79px;" (click)="ImageOpen(data)">
                          </div>


                        </div>
                      </div>

                    </div>


                    <div class="col-lg-4 col-xs-12 col-sm-6">
                      <div>
                        <!--     
                            <agm-map [latitude]="latitude" [longitude]="longitude" [zoom]="14" style="width: 100%; height: 323px; border: 0px;">
                              <agm-marker [latitude]="latitude" [longitude]="longitude" [markerDraggable]="true" (dragEnd)="markerDragEndBranch($event)">
                    
                              </agm-marker>
                          </agm-map>   -->
                      </div>
                    </div>


                    <div class="table-container mt-4"
                      *ngIf="workData.status !== 'New case' && workData.status !== 'Under Validation' && workData.status !== 'Verified'">
                      <div class="tab-container">
                        <button *ngFor="let tab of workData.clientRefId.products" class="add-n1"
                          [class.active]="selectedTab == tab._id" (click)="onTabClick(tab._id)">
                          {{ tab.name }}
                        </button>

                        

                      </div>
                      <br>



                      <table class="table-record">
                        <thead>
                          <tr>
                            <th style="width: 2%;"></th>
                            <th style="width: 9%;">Date</th>
                            <th style="width: 16%;">name</th>

                            <th style="width: 60%;">Text</th>
                            <th style="width: 20%;" class="">Call recordings</th>
                          </tr>
                        </thead>
                        <tbody formArrayName="remarks">
                            <tr>
                            <td colspan="5" class="right-align" style="border-top: 1px solid #fff !important;"
                              *ngIf="this.workData.products[0]._id==selectedTab">
                              <button class="btn-plus" (click)="addRemark()" style="float: right;"><img
                                  src="../../assets/images/plus.png"></button>
                            </td>



                          </tr>
                          <tr *ngFor="let remark of remarks.controls; let i = index" [formGroupName]="i">
                            <td>
                              <div class="bd-in">{{i+1}} </div>
                            </td>
                            <td>
                              <div class="bd-in">
                                <!-- <input type="date" class="form-control" readonly
                                    formControlName="date"> -->
                                {{format(clientForm.value.remarks[i].date)}}

                              </div>
                            </td>
                            <td>
                              <div class="bd-in">
                                <div class="bd-in" style="font-size: 13px;">
                                  <!-- <input type="text" class="form-control" readonly
                                    formControlName="name">  -->
                                  {{clientForm.value.remarks[i].name}}

                                </div>
                              </div>
                            </td>
                            <td>
                              <div class="bd-in">
                                <select *ngIf="!clientForm.value.remarks[i].isDisabled" formControlName="staticRemark"
                                  style="width: 600px;margin-bottom: 4px;"
                                  [(ngModel)]="clientForm.value.remarks[i].staticRemark"
                                  (change)="updateRemark(i,clientForm.value.remarks[i].staticRemark)"
                                  [attr.disabled]="clientForm.value.remarks[i].isDisabled ? true : null">
                                  <!-- <option value="" disabled>Please select....... </option> -->
                                  <!-- Call Status -->
                                  <option [ngValue]="'Call Status - Connected'">Call Status - Connected</option>
                                  <option [ngValue]="'Call Status - Not Connected'">Call Status - Not Connected</option>
                                  <option [ngValue]="'Call Status - Switched Off'">Call Status - Switched Off</option>
                                  <option [ngValue]="'Call Status - Call Back Later'">Call Status - Call Back Later
                                  </option>
                                  <option [ngValue]="'Call Status - Wrong Number'">Call Status - Wrong Number</option>
                                  <option [ngValue]="'Call Status - Number Busy'">Call Status - Number Busy</option>
                                  <option [ngValue]="'Call Status - No Response'">Call Status - No Response</option>
                                  <option [ngValue]="'Call Status - Customer Requested a Call Later'">Call Status -
                                    Customer Requested a Call Later</option>
                                  <option [ngValue]="'Call Status - Customer Disconnected the Call'">Call Status -
                                    Customer Disconnected the Call</option>
                                  <option [ngValue]="'Call Status - Invalid Number'">Call Status - Invalid Number
                                  </option>

                                  <!-- Customer Interest Level -->
                                  <option [ngValue]="'Customer Interest Level - Highly Interested'">Customer Interest
                                    Level - Highly Interested</option>
                                  <option [ngValue]="'Customer Interest Level - Interested'">Customer Interest Level -
                                    Interested</option>
                                  <option [ngValue]="'Customer Interest Level - Neutral'">Customer Interest Level -
                                    Neutral</option>
                                  <option [ngValue]="'Customer Interest Level - Not Interested'">Customer Interest Level
                                    - Not Interested</option>
                                  <option [ngValue]="'Customer Interest Level - Already Taken Service'">Customer
                                    Interest Level - Already Taken Service</option>
                                  <option [ngValue]="'Customer Interest Level - Needs More Information'">Customer
                                    Interest Level - Needs More Information</option>
                                  <option [ngValue]="'Customer Interest Level - Wants to Compare with Other Options'">
                                    Customer Interest Level - Wants to Compare with Other Options</option>
                                  <option [ngValue]="'Customer Interest Level - Asked for a Demo'">Customer Interest
                                    Level - Asked for a Demo</option>
                                  <option
                                    [ngValue]="'Customer Interest Level - Requires Approval from Higher Authority'">
                                    Customer Interest Level - Requires Approval from Higher Authority</option>
                                  <option [ngValue]="'Customer Interest Level - Decision Pending'">Customer Interest
                                    Level - Decision Pending</option>

                                  <!-- Follow-Up Action -->
                                  <option [ngValue]="'Follow-Up Action - Send Details via WhatsApp'">Follow-Up Action -
                                    Send Details via WhatsApp</option>
                                  <option [ngValue]="'Follow-Up Action - Send Details via Email'">Follow-Up Action -
                                    Send Details via Email</option>
                                  <option [ngValue]="'Follow-Up Action - Call Again Tomorrow'">Follow-Up Action - Call
                                    Again Tomorrow</option>
                                  <option [ngValue]="'Follow-Up Action - Call Again Next Week'">Follow-Up Action - Call
                                    Again Next Week</option>
                                  <option [ngValue]="'Follow-Up Action - Call Again Next Month'">Follow-Up Action - Call
                                    Again Next Month</option>
                                  <option [ngValue]="'Follow-Up Action - No Further Follow-Up Required'">Follow-Up
                                    Action - No Further Follow-Up Required</option>
                                  <option [ngValue]="'Follow-Up Action - Schedule a Meeting'">Follow-Up Action -
                                    Schedule a Meeting</option>
                                  <option [ngValue]="'Follow-Up Action - Transfer to Senior Executive'">Follow-Up Action
                                    - Transfer to Senior Executive</option>
                                  <option [ngValue]="'Follow-Up Action - Arrange a Call with Manager'">Follow-Up Action
                                    - Arrange a Call with Manager</option>
                                  <option [ngValue]="'Follow-Up Action - Offer a Discount'">Follow-Up Action - Offer a
                                    Discount</option>

                                  <!-- Reason for Not Interested -->
                                  <option [ngValue]="'Reason for Not Interested - Already Using a Similar Service'">
                                    Reason for Not Interested - Already Using a Similar Service</option>
                                  <option [ngValue]="'Reason for Not Interested - Not in Need Right Now'">Reason for Not
                                    Interested - Not in Need Right Now</option>
                                  <option [ngValue]="'Reason for Not Interested - Found a Better Alternative'">Reason
                                    for Not Interested - Found a Better Alternative</option>
                                  <option [ngValue]="'Reason for Not Interested - Too Expensive'">Reason for Not
                                    Interested - Too Expensive</option>
                                  <option [ngValue]="'Reason for Not Interested - Trust Issues'">Reason for Not
                                    Interested - Trust Issues</option>
                                  <option [ngValue]="'Reason for Not Interested - Not Authorized to Make Decisions'">
                                    Reason for Not Interested - Not Authorized to Make Decisions</option>
                                  <option [ngValue]="'Reason for Not Interested - Bad Past Experience'">Reason for Not
                                    Interested - Bad Past Experience</option>
                                  <option [ngValue]="'Reason for Not Interested - Prefers a Competitor'">Reason for Not
                                    Interested - Prefers a Competitor</option>
                                  <option [ngValue]="'Reason for Not Interested - Delayed Decision Making'">Reason for
                                    Not Interested - Delayed Decision Making</option>
                                  <option [ngValue]="'Reason for Not Interested - Needs More Features'">Reason for Not
                                    Interested - Needs More Features</option>


                                </select>&nbsp;&nbsp;

                                <br>
                                <textarea rows="3"
                                  style="width: 600px; height: 127px; padding: 14px; box-sizing: border-box;"
                                  [attr.disabled]="clientForm.value.remarks[i].isDisabled ? true : null"
                                  formControlName="remark"></textarea>
                              </div>
                            </td>


                            <td class="call-recordings">


                              <button class="add-n" style="position: relative; overflow: hidden;">
                                <input type="file" (change)="upload(i,$event)"
                                  style="opacity: 0; position: absolute; left: 0; top: 0; width: 100%; height: 100%; cursor: pointer;" />
                                Upload

                              </button>
                              <button class="add-n" (click)="removeItem(i)"
                                *ngIf="!clientForm.value.remarks[i].isDisabled "><img
                                  src="../../assets/images/Delete.png"></button>



                              <div class="audio-one" *ngFor="let item of clientForm.value.remarks[i].audioRecording">
                                <audio *ngIf="item" controls>
                                  <source [src]="item" type="audio/wav">
                                </audio>
                                <div class="del-img" (click)="removeAudio(item,i)">
                                  <img src="../../assets/images/Delete.png">
                                </div>
                              </div>
                            </td>
                          </tr>
                        
                        </tbody>
                      </table>
                    </div>
                    
                  

                    <div class="remark-div" *ngIf="showStatusChangeButton1()">
                      <button class="add-remark" (click)="remarkUpdate()">
                        <!-- <img src="../../assets/images/plus-blue.svg"> -->
                        <p>Update remarks</p>
                      </button>
                    </div>

                  </div>

                </form>


                 <div class="content mt-5"
                  *ngIf="!workData.isActive || workData.status=='Not Interested'">

                    <button class="btn-two" (click)="assignTo('me')"
                     *ngIf="!workData.isActive || workData.status=='Not Interested'">Assigned To Me </button>
                  <button class="btn-two" (click)="assignTo('other')"
                     *ngIf="!workData.isActive || workData.status=='Not Interested'">Assigned To Other</button>
                  <label  *ngIf="assignOther && (!workData.isActive || workData.status=='Not Interested') ">Assigned To : </label>
                  <select class="form-control sel" style="width: 200px;height: 42px;border: 4px solid #71787D;"
                    *ngIf="assignOther && (!workData.isActive || workData.status=='Not Interested')"  [(ngModel)]="selectedStaff"
        (ngModelChange)="assignOthers($event)">
                    <option value="" disabled selected>--Select User--</option>
                    <option *ngFor="let staff of this.telleCallers" [ngValue]="staff">{{staff.name}}</option>
                  </select>

                 </div>


                <div class="content mt-5"
                  *ngIf="tab !== 'All Cases'||this.workData.flag=='ADD'||this.storedData.userType[0].userType=='Client Admin'">
                  <div></div>
                  <button class="btn-two" (click)="Allocate('backend')"
                    *ngIf="workData.flag=='EDIT'&&workData.status=='New case'">Allocate</button>
                  <button class="btn-two" (click)="Allocate('tellecaller')"
                    *ngIf="workData.flag=='EDIT'&&workData.status=='Verified'">Allocate</button>

                  
                  <!-- <button class="add-n" (click)="StatusChangemodal=true" *ngIf="workData.flag=='EDIT'&&workData.status!='Under Validation'&&workData.status!='Verified'">Next</button> -->

                  <!---->
                  <button class="btn-two" (click)="toggleEdit()">
                    {{ isEditing ? 'Save' : 'Edit' }}
                  </button>
                  <button class="btn-two" *ngIf="workData.status=='Under Validation'"
                    (click)="SaveStatus('Verified')">Verified</button>

                  <button class="btn-two ext-two" *ngIf="this.workData.flag!='ADD'" (click)="previous()"><img
                      src="../../assets/images/keyboard_double_arrow_left.png">
                    <p>Send to previous step</p>
                  </button>
                  <!-- change -->
                  <!-- <div > -->
                  <!-- First Dropdown -->
                  <select [(ngModel)]="selectedValue1" class="form-control sel" style="width: 200px;"
                    *ngIf="showStatusChangeButton()&&workData.status=='Under TeleCall'" (change)="setSecondDropdown()">
                    <!-- <option value="" disabled>Select First Dropdown</option> -->
                    <option *ngFor="let option of dropdownData" [value]="option.first">{{ option.first }}</option>
                  </select>

                  <!-- Second Dropdown (Static Options) -->
                  <select class="form-control sel" [(ngModel)]="statusChange" [ngModelOptions]="{standalone:true}"
                    style="width: 200px;" *ngIf="showStatusChangeButton()&&workData.status=='Under TeleCall'">
                    <!-- <option value="" disabled>Select Second Dropdown</option> -->
                    <option value="Interested">Interested</option>
                    <option value="Not Interested">Not Interested</option>
                    <option value="Reminder">Move To Reminder</option>



                  </select>
                  <!-- </div> -->

                  <!-- change end -->
                  <button class="btn-two ext-two" (click)="ChangeStatus()" *ngIf="showStatusChangeButton()">
                    <p>Proceed</p><img src="../../assets/images/keyboard_double_arrow_right.png">
                  </button>

                </div>

                <div class="content mt-5">
                  <button class="add-n" (click)="router.navigate(['/work-page'])">Cancel</button>

                </div>


              </div>
              <div id="show-img" class="overlay" *ngIf="showMap">
                <div class="col-lg-6" style="background-color: #fff;">

                  <div class="form-group">
                    <input type="text" class="form-control" (keydown.enter)="$event.preventDefault()"
                      placeholder="Search Nearest Location" autocorrect="off" autocapitalize="off" spellcheck="off"
                      type="text" #agmSearch>
                  </div>


                  <div class="form-group">
                    <input [(ngModel)]="lat1" type="text" placeholder="Latitude" (input)="setLatitude($event)">
                    <input [(ngModel)]="long1" type="text" placeholder="Longitude" (input)="setLongitude($event)">

                  </div>



                  <agm-map [latitude]="latitude" [longitude]="longitude" [zoom]="14"
                    style="width: 100%; height: 323px; border: 0px;">
                    <agm-marker [latitude]="latitude" [longitude]="longitude" [markerDraggable]="true"
                      (dragEnd)="markerDragEndBranch($event)">

                    </agm-marker>
                  </agm-map>
                  <div class="content">
                    <button class="add-n" (click)="ok()">OK</button>
                  </div>
                </div>


              </div>

            </div>

          </div>

        </div>


      </main>

    </div>
  </div>



  <!-- <div class="footer-section2">
    
        <img src="../../assets/images/accruon-footer (2).png">
      </div> -->
</body>
















<!-- <div id="" class="overlay" *ngIf="StatusChangemodal">
  <div class="popup-ins" id="popup-ins1">
      <div class="ins-f" id="ins-f1">
      <h2>Status Change</h2>
         
          <form class="staff-form mt-2">
              <div class="row">
                  <div class="col-lg-12 col-xs-12 col-sm-6">
              <div class="form-group">
                 <select class="select-al"               [(ngModel)]="statusChange"  
                 [ngModelOptions]="{standalone:true}"
                 >
                              <option value="Interested" *ngIf="workData.status=='Under TeleCall'">Interested</option>
                              <option value="Field Visit" *ngIf="workData.status=='Interested'"> Field Visit</option>
                                                          <option value="Client Enrolled" *ngIf="workData.status=='Field Visit'&&this.storedData.userType[0].userType=='Manager'" >Client Enrolled</option>              

                              <option value="Not Interested">Not Interested</option>
                              <option value="Reminder">Move To Reminder</option>

                            </select> &nbsp;
                            <input type="date"  class="form-control"   [min]="today"
                            [(ngModel)]="reminderDate"  *ngIf="statusChange=='Reminder'"
                            [ngModelOptions]="{standalone:true}">&nbsp;

                            <input type="time"  class="form-control"  
                            [(ngModel)]="reminderTime"  *ngIf="statusChange=='Reminder'"
                            [ngModelOptions]="{standalone:true}">&nbsp;


&nbsp;

<label *ngIf="statusChange=='Reminder'">ReminderTo</label>
                            <select 
                            *ngIf="statusChange=='Reminder'"
                            class="form-control " 
                            [(ngModel)]="reminderTo" 
                            [ngModelOptions]="{standalone:true}"
                            >
                            <option 
                              *ngFor="let option of reminderToArray || []" 
                              [value]="option._id">
                              {{ option.name}}
                            </option>
                          </select>&nbsp;
                          <label *ngIf="statusChange=='Reminder'">ReminderRemark</label>

                          <textarea  *ngIf="statusChange=='Reminder'"
                          class="form-control " 
                          [(ngModel)]="reminderComment" 
                          maxlength="50" 
                          [ngModelOptions]="{standalone:true}"></textarea>
                         


                          <label *ngIf="statusChange=='Reminder'&&submitted&&(!reminderComment||!reminderTo||!reminderDate)" style="color: red;">Please fill required field</label>

              </div>
              </div>
          </div>
          </form>
  </div>

      <div class="ins-footer">
  <button class="btn-sec" (click)="StatusChangemodal=false">Back</button>
  <button class="btn-prime" (click)="StatusChange()">Submit</button>
  </div>

  </div>
</div>  -->




<div id="" class="overlay" *ngIf="StatusChangemodal">
  <div class="popup-ins" id="popup-ins1">
    <div class="ins-f" id="ins-f1">
      <h2>Status Change</h2>

      <form class="staff-form mt-2">
        <div class="row">
          <div class="col-lg-12 col-xs-12 col-sm-6">
            <div class="form-group">
              <select class="select-al" [(ngModel)]="statusChange" [ngModelOptions]="{standalone:true}">
                <!-- <option value="Interested" *ngIf="workData.status=='Under TeleCall'">Interested</option> -->
                <!-- change -->
                <option value="Demo" *ngIf="workData.status === 'Interested'">Demo</option>
                <!-- <option value="Demo">Demo</option> -->

                <!-- If status is Demo -->
                <!-- <option value="Proposal Sent" *ngIf="workData.status === 'Demo'">Proposal Sent</option> -->
                <option value="Proposal Sent" *ngIf="workData.status != 'Field Visit' && workData.status != 'Proposal Sent'">Proposal Sent</option>


                <!-- <option value="Field Visit" *ngIf="workData.status=='Proposal Sent'"> Field Visit</option> -->
                <option value="Field Visit" *ngIf="workData.status != 'Field Visit'"> Field Visit</option>

                <option value="Online"> Online</option>
                <option value="Offline"> Offline</option>

                <option value="Client Enrolled"
                  *ngIf="workData.status=='Field Visit'&&this.storedData.userType[0].userType=='Manager'||workData.status=='Field Visit'&&this.storedData.userType[0].userType=='Client Admin'">
                  Client Enrolled</option>

                <option value="Not Interested">Not Interested</option>
                <option value="Reminder">Move To Reminder</option>

              </select> &nbsp;
              <input type="date" class="form-control" [min]="today" [(ngModel)]="reminderDate"
                *ngIf="statusChange=='Reminder'" [ngModelOptions]="{standalone:true}">&nbsp;

              <input type="time" class="form-control" [(ngModel)]="reminderTime" *ngIf="statusChange=='Reminder'"
                [ngModelOptions]="{standalone:true}">&nbsp;
              <!-- 
                            <input type="text"  class="form-control"  
                            [(ngModel)]="reminderTo"  *ngIf="statusChange=='Reminder'"
                            [ngModelOptions]="{standalone:true}"> -->

              &nbsp;

              <label *ngIf="statusChange=='Reminder'">ReminderTo</label>
              <select *ngIf="statusChange=='Reminder'" class="form-control " [(ngModel)]="reminderTo"
                [ngModelOptions]="{standalone:true}">
                <option *ngFor="let option of reminderToArray || []" [ngValue]="option">
                  {{ option.name}}
                </option>
              </select>&nbsp;
              <label *ngIf="statusChange=='Reminder'">ReminderRemark</label>

              <textarea *ngIf="statusChange=='Reminder' && storedData.userType[0].userType == 'Tele Caller'"
                class="form-control " [(ngModel)]="reminderComment" maxlength="50"
                [ngModelOptions]="{standalone:true}"></textarea>
              <select *ngIf="statusChange=='Reminder' && storedData.userType[0].userType !== 'Tele Caller'"
                class="form-control" [(ngModel)]="selectedOption" [ngModelOptions]="{standalone:true}">
                <option *ngFor="let option of reminderOptions || []" [value]="option">{{ option }}</option>
              </select>

              <!-- Input field if 'Other' is selected -->
              <input
                *ngIf="statusChange=='Reminder' && storedData.userType[0].userType !== 'Tele Caller'&&selectedOption === 'Other'"
                type="text" class="form-control" [(ngModel)]="reminderComment" placeholder="Enter your remark"
                [ngModelOptions]="{standalone:true}">

              <label *ngIf="statusChange=='Reminder'&&submitted&&(!reminderComment||!reminderTo||!reminderDate)"
                style="color: red;">Please fill required field</label>

              <!-- <input type="text"  class="form-control"  
                            [(ngModel)]="reminderTo"  *ngIf="statusChange=='Reminder'"
                            [ngModelOptions]="{standalone:true}"> -->
            </div>
          </div>
        </div>
      </form>
    </div>

    <div class="ins-footer">
      <button class="btn-sec" (click)="statusChange='';StatusChangemodal=false">Back</button>
      <button class="btn-prime" (click)="StatusChange()">Submit</button>
    </div>

  </div>
</div>